/** Copy of TextAlignProperty from csstype (works around TS error) */
// This is probably removable if we turn off isolatedModules in the future (then we can just
// re-export TextAlignProperty).)
export var translateAlignProp = function translateAlignProp(textAlignProp) {
  // This assignment verifies that the copy of TextAlignProperty matches up with the real one.
  var alignProp = textAlignProp;

  switch (alignProp) {
    case 'start':
      return 'left';

    case 'end':
      return 'right';

    default:
      return alignProp;
  }
};
//# sourceMappingURL=translateAlignProp.js.map
